module.exports = __webpack_public_path__ + "operace-nosu_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_4_before.jpg
// module id = 1136
// module chunks = 0